import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IManual } from '../features/manuals/models/ManualModel';
import { IProcessingIssue } from '../features/manuals/models/ProcessingIssue';

export interface MenuNode {
  label: string;
  pageNumber?: number;
  children?: MenuNode[];
}

@Injectable({
  providedIn: 'root',
})
export class ManualService {

  private readonly http = inject(HttpClient);

  getManuals() {
    return this.http.get<IManual[]>(`${environment.API_URL}/api/manuals`);
  }

  getManualById(id: string) {
    return this.http.get<IManual>(`${environment.API_URL}/api/manuals/${id}`);
  }

  updateManual(manualId: string, data: Partial<IManual>) {
    return this.http.put<any>(`${environment.API_URL}/api/manuals/${manualId}`, data);
  }

  digitalizeManual(manualId: string) {
    return this.http.post(`${environment.API_URL}/api/manuals/${manualId}`, {});
  }

  pauseManualProcessing(manualId: string) {
    return this.http.post(`${environment.API_URL}/api/manuals/${manualId}/pause`, {});
  }

  reprocessImage(manualId: string, pageNumber: number ,restyle: boolean = false) {
    return this.http.post(`${environment.API_URL}/api/manuals/${manualId}/reprocess`, { pageNumber, restyle });
  }

  navigateManualPage(manualId: string, page:number) {
    return this.http.get(`${environment.API_URL}/api/manuals/navigate/${manualId}?page=${page}`);
  }

  deleteManualPage(manualId: string, pageNumber: number) {
    return this.http.delete(`${environment.API_URL}/api/manuals/${manualId}/pages/${pageNumber}`);
  }

  deleteManual(manualId: string) {
    return this.http.delete(`${environment.API_URL}/api/manuals/${manualId}`);
  }

  getProcessingIssues(page?: number, limit?: number) {
    let params = new HttpParams();
    if (page !== undefined) params = params.set('page', (page + 1).toString());
    if (limit !== undefined) params = params.set('limit', limit.toString());
    return this.http.get<{ data: IProcessingIssue[], total: number }>(`${environment.API_URL}/api/manuals/processing-issues`, { params });
  }

  getProcessingIssuesByManualId(manualId: string, page?: number, limit?: number) {
    let params = new HttpParams();
    if (page !== undefined) params = params.set('page', (page + 1).toString());
    if (limit !== undefined) params = params.set('limit', limit.toString());
    return this.http.get<{ data: IProcessingIssue[], total: number }>(`${environment.API_URL}/api/manuals/${manualId}/processing-issues`, { params });
  }

  updateProcessingIssue(issueId: string, data: Partial<any>) {
    return this.http.patch<any>(`${environment.API_URL}/api/manuals/processing-issues/${issueId}`, data);
  }
  
}
